import { render, staticRenderFns } from "./ownerDialog.vue?vue&type=template&id=4bab6a92&scoped=true&"
import script from "./ownerDialog.vue?vue&type=script&lang=ts&"
export * from "./ownerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ownerDialog.vue?vue&type=style&index=0&id=4bab6a92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab6a92",
  null
  
)

export default component.exports